export const LOAD_CONTENT = 'hg/review/LOAD_CONTENT';
export const DL_PAGE_LOADED = 'hg/review/DL_PAGE_LOADED';
export const SUBMIT_ORDER = 'hg/review/SUBMIT_ORDER';

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/QuickCheckout/review/review.js
 **/